import { type STORAGE_LIMIT_EDITIONS, getIsOverEditionLimit } from '../storageLimits/storageLimits.ts';

export enum BannerThresholds {
	MIN = 90,
	MAX = 100,
}

export const getBannerThreshold = (
	currentUsage: number,
	edition: STORAGE_LIMIT_EDITIONS,
): BannerThresholds => {
	return getIsOverEditionLimit(currentUsage, edition) ? BannerThresholds.MAX : BannerThresholds.MIN;
};
